import { cs, enUS } from 'date-fns/locale';

export default defineNuxtPlugin(() => {
  return {
    provide: {
      dateFnsLocales: { cs, en: enUS },
    },
  };
});
